import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBi6UHGfVK3lupbyk31uTJtqMRDRgkHnnQ",
  authDomain: "gdfeitos-93e0d.firebaseapp.com",
  projectId: "gdfeitos-93e0d",
  storageBucket: "gdfeitos-93e0d.firebasestorage.app",
  messagingSenderId: "149008811585",
  appId: "1:149008811585:web:e35f7ec45d84f80c3e68c0",
  measurementId: "G-F2HYBKK7TP"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar autenticação e provider Google
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
